import { newProducts } from "../assets/data/newProducts.js";
import { getNewProductsReducer, getNewProductByIdReducer, filterByBrandReducer, filterByCategoryReducer } from "./newProductSlice.js";

export const getNewProducts = () => {
    return (dispatch) => {
        dispatch(getNewProductsReducer(newProducts));
    };
};

export const getNewProductById = (productId) => {
    return (dispatch) => {
        dispatch(getNewProductByIdReducer(productId))
    };
};

export const filterByBrand = (rooms) => {
    return async (dispatch) => {
        dispatch(filterByBrandReducer(rooms));
    };
};

export const filterByCategory = (type) => {
    return async (dispatch) => {
        dispatch(filterByCategoryReducer(type));
    };
};

// export const orderByPrice = (order) => {
//     return async (dispatch) => {
//         dispatch(orderByPriceReducer(order));
//     };
// };